import { render, staticRenderFns } from "./ContractOrder.vue?vue&type=template&id=5710dcc0&scoped=true&"
import script from "./ContractOrder.vue?vue&type=script&lang=js&"
export * from "./ContractOrder.vue?vue&type=script&lang=js&"
import style0 from "./ContractOrder.vue?vue&type=style&index=0&id=5710dcc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710dcc0",
  null
  
)

export default component.exports